module.exports = __webpack_public_path__ + "img/p2-36.3a574592.png";